<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Epigraphs</a></p>
<p class="toc sub"><a href="#/front04">Author’s Note</a></p>
<p class="part"><a href="#/c001">GOLD</a></p>
<p class="toc"><a href="#/c01">Celestial Railroad</a></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">SILVER</span></p>
<p class="toc"><span href="#/c02" title="Link target outside of Sample">Your Name in Chinese</span></p>
<p class="part"><span href="#/c003" title="Link target outside of Sample">JADE</span></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">Tell It Slant</span></p>
<p class="part"><span href="#/c004" title="Link target outside of Sample">PEARL</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Disorientation</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Reading Group Guide</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">A Conversation with Peter Ho Davies</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Sample Chapter from A LIE SOMEONE TOLD YOU ABOUT YOURSELF</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Buy the Book</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back07" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?bd09ead6